import styled from 'styled-components';
interface MatchWatchProps {
  noWidth?: boolean;
}

export default styled.div<MatchWatchProps>`
  width: ${(props) => (props.noWidth ? 'auto' : '100px')};
  text-align: center;
  white-space: nowrap;

  .clock {
    font-family: 'Overpass Mono', sans-serif;
  }
`;
